/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';
import type { WarehouseDTO } from './WarehouseDTO';
import {
    WarehouseDTOFromJSON,
    WarehouseDTOFromJSONTyped,
    WarehouseDTOToJSON,
} from './WarehouseDTO';

/**
 * 
 * @export
 * @interface WarehousePageDTO
 */
export interface WarehousePageDTO {
    /**
     * 
     * @type {Array<WarehouseDTO>}
     * @memberof WarehousePageDTO
     */
    content?: Array<WarehouseDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof WarehousePageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WarehousePageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WarehousePageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof WarehousePageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof WarehousePageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof WarehousePageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof WarehousePageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof WarehousePageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof WarehousePageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the WarehousePageDTO interface.
 */
export function instanceOfWarehousePageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WarehousePageDTOFromJSON(json: any): WarehousePageDTO {
    return WarehousePageDTOFromJSONTyped(json, false);
}

export function WarehousePageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehousePageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(WarehouseDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function WarehousePageDTOToJSON(value?: WarehousePageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(WarehouseDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

